<template>
  <div class="info-bubble" :class="{showing: value}">
    <slot></slot>
    <div class="info-triangle"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean
  }
}
</script>

<style>

  .info-bubble{
    opacity:0;
    color:#fff;
    background-color:#a7aba1;
    text-align:center;
    max-width:80vw;
    width:300px;
    position:absolute;
    top:0;
    right:0;
    padding:10px;
    pointer-events: none;
    border-radius:5px;
    display:block;
    white-space: normal;
    font-size:14px;
    line-height:18px;
    transition:all 0.2s linear;
    transform:translate(0, calc(-100% - 7px)) scale(0.1);
    transform-origin:90% 120%;
  }

  .info-bubble .info-triangle{
    width:0;
    height:0;
    border-left:10px solid transparent;
    border-right:10px solid transparent;
    border-top:10px solid #a7aba1;
    position:absolute;
    right:10%;
    bottom:-8px;
  }

  .nav-button:hover .info-bubble{
    opacity:1;
    transform:translate(0,calc(-100% - 12px));
  }


</style>